import React from 'react';
import ReactDOM from 'react-dom/client';
import './generated.css';
import App from './App.js';
import { CountProvider } from './context/CountContext.js';
import './index.css';
import { AuthProvider } from './AuthContext.js';


const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <CountProvider>
        <App />
      </CountProvider>
    </AuthProvider>
  </React.StrictMode>
);
